import { ReactNode } from 'react';

interface TitleProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}

const Title = ({ children, className = '', onClick }: TitleProps) => {
  return (
    <div className={className} data-testid="cta-subnav-title" onClick={onClick}>
      {children}
    </div>
  );
};

export default Title;
